import ContentCardList from './component.jsx'
export default ContentCardList
